if (typeof __DEV__ !== 'undefined' && typeof globalThis !== 'undefined') {
  globalThis.__DEV__ = __DEV__;
}
